import { createContext } from "react";

export type RecordingStatusContextType = {
  isRecording: boolean;
};

export const RecordingStatusContext = createContext<RecordingStatusContextType | null>(null);
